module.exports = __webpack_public_path__ + "img/loading.8a219347.gif";